import { useEffect, useState } from "react";
import { partnerApi, type PartnerReferral, type PartnerSubAgent } from "@/lib/api";
import { Card, PageLoader, Row, Badge, rub, usd, fmtDate } from "@/components/ui";

const KYC: Record<PartnerReferral["kyc"], { label: string; tone: "green" | "amber" | "red" | "muted" }> = {
  verified: { label: "Проверен", tone: "green" },
  pending: { label: "На проверке", tone: "amber" },
  rejected: { label: "Отказ", tone: "red" },
  none: { label: "Без проверки", tone: "muted" },
};

export function Referrals() {
  const [clients, setClients] = useState<PartnerReferral[] | null>(null);
  const [subAgents, setSubAgents] = useState<PartnerSubAgent[]>([]);

  useEffect(() => {
    partnerApi
      .referrals()
      .then((r) => {
        setClients(r.clients);
        setSubAgents(r.sub_agents);
      })
      .catch(() => setClients([]));
  }, []);

  if (clients === null) return <PageLoader />;

  return (
    <div className="space-y-3 pt-2">
      <div>
        <div className="text-xl font-bold">Мои клиенты</div>
        <p className="mt-1 text-sm text-white/45">Данные обезличены — только статистика.</p>
      </div>

      {clients.length === 0 && (
        <Card>
          <p className="text-sm text-white/50">
            Пока никого. Поделитесь ссылкой или кодом — приведённый клиент появится здесь.
          </p>
        </Card>
      )}

      {clients.map((c) => (
        <Card key={c.id}>
          <div className="flex items-center justify-between">
            <span className="font-mono text-sm">{c.id}</span>
            <Badge tone={KYC[c.kyc].tone}>{KYC[c.kyc].label}</Badge>
          </div>
          <div className="mt-2">
            <Row left={<span className="text-white/50">Привлечён</span>} right={fmtDate(c.attached_at)} />
            <Row left={<span className="text-white/50">Оборот</span>} right={rub(c.turnover_rub)} />
            <Row left={<span className="text-white/50">Начислено</span>} right={usd(c.earned_usd)} />
          </div>
        </Card>
      ))}

      {subAgents.length > 0 && (
        <>
          <div className="mt-4">
            <div className="text-base font-semibold">Второй уровень</div>
            <p className="mt-1 text-sm text-white/45">Партнёры, которых привели вы — их оборот и ваша доля.</p>
          </div>
          {subAgents.map((s) => (
            <Card key={s.id}>
              <div className="font-mono text-sm">{s.id}</div>
              <div className="mt-2">
                <Row left={<span className="text-white/50">Оборот их клиентов</span>} right={rub(s.turnover_rub)} />
                <Row left={<span className="text-white/50">Начислено вам</span>} right={usd(s.earned_usd)} />
              </div>
            </Card>
          ))}
        </>
      )}
    </div>
  );
}
